import { V3 } from '../api_request';
import alt from '../alt';
import URLHelpers from '../shared/url_helpers';

const DEFAULT_PARAMS = {
  include_grid_images: true,
  paginate_bump: true,
  expand_category_facets: false,
  middle_categories: true,
  shipping_placeholders: true,
};

class ListingsActions {
  errorLoadingListings() {
    return null;
  }

  listingsLoaded(response) {
    return response;
  }

  listingsLoading() {
    return null;
  }

  preloadClear() {
    return null;
  }

  searchForGrid(params) {
    const decoratedParams = Object.assign(params, DEFAULT_PARAMS);
    const promise = V3.get(URLHelpers.listingsGridPath(), decoratedParams);

    this.listingsLoading();

    promise.then((response) => {
      this.listingsLoaded(response);
    })
      .fail((_xhr, status, err) => {
        this.errorLoadingListings();
        this.throwError(status, err);
      });

    return promise;
  }

  searchForSimilarListings(listingId, page = 1) {
    const promise = V3.get(URLHelpers.similarListings(listingId), { page });

    promise.then((response) => {
      this.listingsLoaded(response);
    })
      .fail((_xhr, status, err) => {
        this.errorLoadingListings();
        this.throwError(status, err);
      });

    return promise;
  }

  throwError(status, err) {
    throw new Error(`failed to fetch listings - status: ${status}, err: ${err}`);
  }
}

export default alt.createActions(ListingsActions);
